/**
 * Represents the types of minimum wage rules.
 */
export enum MinimumWageRuleType {
    /** Global AYA rule */
    Aya = 1,
    /** Rule based on government entities */
    Government = 2,
    /** Rule for a Facility or Facility System */
    Facility = 3
}
